import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import "./presentation.css";
import Quot from "../components/quote";
import Emoji from "../components/Emoji"

const CV     = () => {
    const data = useStaticQuery(graphql`
      {
        file(extension: {eq: "pdf"}) {
          publicURL
        }
      }
    `)
    return (
      <li className="itemLink">
          <a href={data.file.publicURL}><img src="/assets/cvlogo.png" alt="cv" /></a>
      </li>
    )
  }
export default () => (
    <div className="presentation">
        <div className="sagesse">
          <Quot />
        <img className="prof" src="/assets/path926.png" alt="profil" />
        </div>
        
        <h1 className="headline"><Emoji label="rocket" symbol="🚀" /> Hello there, I'm Saintil Dit Laguerre Donfred,</h1><br />
        
        <p>I'm a security expert who likes testing out new and interesting technologies. I'm passionate about security, that's the reason why this blog exists. I really like challenges and I am exited about what I will encounter in my career.</p>
        <p>Find out above my profiles over the internet: </p>
        
        <ul className="socialLinks">
            <li className="itemLink">
                <a href="https://www.root-me.org/sagessegina"><img src="/assets/root-me31.png" alt="nad" /></a>
            </li>
            <li className="itemLink">
                <a href="https://twitter.com/fredydev"><img src="/assets/twitt.png" alt="twitter" /></a>
            </li>
            <li className="itemLink">
                <a href="https://github.com/fredydev"><img src="/assets/git.png" alt="github" /></a>
            </li>
            <li className="itemLink">
                <a href="https://www.linkedin.com/in/donfred-saintil-dit-laguerre-69245832/"><img src="/assets/linkedin.png" alt="linkedin" /></a>
            </li>
            <CV />
        </ul>
      
        
    </div>
)